import axios from 'axios'

const state = { itemCategories: [] }

const getters = {
	itemMajorCategories(state) {
		const majorCategories = []
		state.itemCategories.forEach(category => {
			const itemMajorCategory = category.ItemMajorCategory
			if (itemMajorCategory) {
				const inMajorCategories = majorCategories.some(
					mj => mj.id === itemMajorCategory.id
				)
				if (!inMajorCategories) majorCategories.push(itemMajorCategory)
			}
		})
		return majorCategories
	}
}

const actions = {
	findAll(context) {
		const { startDate, endDate, pickUpBranch } = context.rootState.order
		return axios
			.get(
				`item-category?startDate=${startDate.toDate()}&endDate=${endDate.toDate()}&branch_id=${
					pickUpBranch.id
				}`
			)
			.then(res => {
				context.commit('SET_ITEM_CATEGORIES', res.data)
				context.commit('order/RESET_POSITIONS', null, { root: true })
			})
	}
}

const mutations = {
	SET_ITEM_CATEGORIES(state, value) {
		state.itemCategories = value
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
